(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["t4s_group_btns"] && !Shopify.designMode) return;
  try {
    $(document).ready(function() {
		$(".no-search-trigger").on("click.disable", function(e) {
			e.preventDefault();  
			e.stopPropagation();  
			console.log("点击被禁用");
		 	$(this).toggleClass('search-trigger-hide');
		 	$('.t4s-custom-search').toggleClass('t4s-custom-invisible');			
		});		
	});

	$(document).ready(function() {
		// var $searchBtn = $(".no-search-trigger");
		// function toggleSearchBehavior() {
		// 	// if ($(window).width() <= 768) {
		// 	// 	$searchBtn.off("click.disableSearch");
		// 	// } else {				
		// 	// 	$searchBtn.off("click.disableSearch").on("click.disableSearch", function(e) {
		// 	// 		e.preventDefault();
		// 	// 		e.stopPropagation();
		// 	// 	});
		// 	// 	$('.no-search-trigger').click(function(){
		// 	// 		$(this).toggleClass('search-trigger-hide');
		// 	// 		$('.t4s-custom-search').toggleClass('t4s-custom-invisible');
		// 	// 	});				
		// 	// }								
		// }
		// toggleSearchBehavior();
		// $(window).resize(toggleSearchBehavior);

		$('.t4s-iconsvg-close').click(function(){
			$(this).parents().removeClass('t4s-custom-invisible');
			$('.no-search-trigger').removeClass('search-trigger-hide');
		})
	});
  } catch(e) { console.error(e); }
})();

})();
